import { config } from "~/data/config";
import { RnrPortalsJson } from "~/server/types/client";

export function getStaticJson(key: string) {
  return fetch(`https://app.myhubble.money/ssr/${key}`, {}).then((response) =>
    response.json()
  );
}

export async function getStaticRnrPortalsJson(
  key: string
): Promise<RnrPortalsJson> {
  const envPath = config.env === "Prod" ? "prod" : "staging";
  const baseUrl = `https://app.myhubble.money/rnr-portals/${envPath}`;

  try {
    const response = await fetch(`${baseUrl}/${key}.json`);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch ${key}.json, status: ${response.status}`
      );
    }
    return await response.json();
  } catch (error) {
    const fallbackResponse = await fetch(`${baseUrl}/fallback.json`);
    return await fallbackResponse.json();
  }
}

export function getStaticProxyJson(key: string) {
  return fetch(`https://app.myhubble.money/static/proxy/${key}`, {}).then(
    (response) => response.json()
  );
}

export function getMarkdown(key: string) {
  return fetch(`https://renderer.myhubble.money/v3/api/static/${key}`, {}).then(
    (response) => response.json()
  );
}

export function getJson<T>(key: string) {
  return fetch(`https://renderer.myhubble.money/v3/api/static/${key}`, {}).then(
    (response) => response.json() as T
  );
}
